import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export async function generatePdf(
  cadastros,
  nomeProfissional,
  total_de_visitas_realizadas,
  data_inicio,
  data_fim
) {
  let title_pdf = 'Relatório atendimentos'
  let description_pdf =
    'Atendimentos, procedimentos, vacinas ou visitas realizados nos últimos 90 dias'
  let headers_pdf = ['DATA', 'MANHÃ', 'TARDE', 'NOITE', 'TOTAL']
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.dt_atendimento = utils.methods.formatDate(cadastros[i].dt_atendimento)
    obj.manha = cadastros[i].manha
    obj.tarde = cadastros[i].tarde
    obj.noite = cadastros[i].noite
    obj.total_dia = cadastros[i].total_dia
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  let rows = []
  for (let i = 0; i < data_pdf.length; i++) {
    rows[i] = Object.values(data_pdf[i])
  }
  let table = []
  for (var i = 0; i < rows.length; i++) {
    var tableRow = rows[i]
    for (var i = 0; i < rows.length; i++) {
      var tableRow = rows[i]
      var rowData = []
      if (tableRow.length != 0) {
        for (var j = 0; j < tableRow.length; j++) {
          rowData.push(tableRow[j])
        }
      } else {
        continue
      }
      table.push(rowData)
    }
  }

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      // ACS
      doc.setFontSize(12)
      doc.text(
        'Profissional: ' + nomeProfissional,
        15,
        verticalPosition,
        null,
        null,
        'left'
      )
      verticalPosition += 6
      doc.text(
        'Atendimentos realizados: ' + total_de_visitas_realizadas,
        15,
        verticalPosition,
        null,
        null,
        'left'
      )

      // Data atual
      verticalPosition += 6
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(12)
      doc.text(`Data: ${dataAtual}`, 15, verticalPosition, null, null)

      verticalPosition += 6
      let valorStartY = verticalPosition
      if (data_inicio !== '' && data_fim !== '') {
        let periodo =
          'Período: ' +
          utils.methods.formatDate(data_inicio) +
          ' até ' +
          utils.methods.formatDate(data_fim)
        doc.text(periodo, 15, verticalPosition, null, null, 'left')
        valorStartY = verticalPosition += 5
      }

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: valorStartY,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(title_pdf + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
